import i18n from "@/i18n";
import { computed } from "vue-demi";

export function useI18n() {
  const locale = computed({
    get: () => i18n.locale,
    set: v => (i18n.locale = v)
  });

  return {
    locale,

    /**
     * @param {import("vue-i18n").Path} key
     * @param {import("vue-i18n").Values} values
     * @returns {import("vue-i18n").TranslateResult}
     */
    t: (key, values) => i18n.t(key, values),

    /**
     * @param {import("vue-i18n").Path} key
     * @param {import("vue-i18n").Choice} choice
     * @param {import("vue-i18n").Values} values
     * @returns {string}
     */
    tc: (key, choice, values) => i18n.tc(key, choice, values)
  };
}
